import { TestRequest } from './service-models/test/TestRequest';
import { TestResult } from './service-models/test/TestResult';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
import { TestBaseService } from './TestBaseService';
import { AddressRequest } from './service-models/test/address/AddressRequest';
import { AddressResult } from './service-models/test/address/AddressResult';
import { BaseLineService } from './BaseLineService';
import { HttpUtils } from '../common/http/HttpUtils';

export class AddressService extends BaseLineService {
	/**
	 * テスト検索
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public searchAdrs(viewCore: WprBaseViewCore, request: AddressRequest, resMethod: (result: any) => void): void {
		return this.doPostToExternalAPI(viewCore, '/common/address/addressSearch', request, resMethod);
	}
}